var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSliderRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 23,
    viewBox: "0 0 13 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.292893 22.7071C-0.0976311 22.3166 -0.0976312 21.6834 0.292893 21.2929L10.0858 11.5L0.292892 1.70711C-0.097632 1.31658 -0.0976321 0.683418 0.292892 0.292892C0.683416 -0.0976315 1.31658 -0.0976315 1.70711 0.292892L12.9142 11.5L1.70711 22.7071C1.31658 23.0976 0.683418 23.0976 0.292893 22.7071Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderRightArrow);
export default __webpack_public_path__ + "static/media/sliderRightArrow.5d03940785f0b3794cfb35c4f15f8175.svg";
export { ForwardRef as ReactComponent };